import styled from 'styled-components'
import { Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${Media.Phone`
    gap: 16px;
  `}
`

export const Content = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${Spacing.XS};
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: auto;
`
